import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/quizzes`, {
  get: {
    'quiz.get': '/:id'
  },
  post: {
    'quiz.create': '/'
  },
  put: {
    'quiz.save': '/:quizId'
  }
});
